import i18n from '@/i18n';

import type { OpsPublishOption } from '.';

export const BASE_TASK_OPTIONS: OpsPublishOption[] = [
  {
    get label() {
      return i18n.t('data-center:ops.option.multimodal.tasks');
    },
    value: 'multimodal.tasks',
    children: [
      {
        get label() {
          return i18n.t('data-center:ops.option.visual.multimodal.understanding');
        },
        value: 'visual.multimodal.understanding',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.text.to.image');
        },
        value: 'text.to.image',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.image.captioning');
        },
        value: 'image.captioning',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.text.to.video');
        },
        value: 'text.to.video',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.video.captioning');
        },
        value: 'video.captioning',
      },
      {
        get label() {
          return i18n.t('home:market.application.capability.vision');
        },
        value: 'market.application.capability.vision',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.multimodal.representation');
        },
        value: 'multimodal.representation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.vision.question.answering');
        },
        value: 'vision.question.answering',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.video.question.answering');
        },
        value: 'video.question.answering',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.image.text.retrieval');
        },
        value: 'image.text.retrieval',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.visual.entailment');
        },
        value: 'visual.entailment',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.generative.multimodal.representation');
        },
        value: 'generative.multimodal.representation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.multimodal.similarity');
        },
        value: 'multimodal.similarity',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.document.understanding');
        },
        value: 'document.understanding',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.temporal.video.localization');
        },
        value: 'temporal.video.localization',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.generative.model.fine.tuning');
        },
        value: 'generative.model.fine.tuning',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.multimodal.dialogue');
        },
        value: 'multimodal.dialogue',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.image.to.video');
        },
        value: 'image.to.video',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.unified.multimodal');
        },
        value: 'unified.multimodal',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.image.to.image');
        },
        value: 'image.to.image',
      },
      {
        get label() {
          return i18n.t('home:market.embodied');
        },
        value: 'market.embodied',
      },
    ],
  },
  {
    get label() {
      return i18n.t('data-center:ops.option.natural.language.processing');
    },
    value: 'natural.language.processing',
    children: [
      {
        get label() {
          return i18n.t('data-center:model.capability.modality.textGeneration');
        },
        value: 'model.capability.modality.textGeneration',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.text.classification');
        },
        value: 'text.classification',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.tokenization');
        },
        value: 'tokenization',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.named.entity.recognition');
        },
        value: 'named.entity.recognition',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.machine.translation');
        },
        value: 'machine.translation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.text.summarization');
        },
        value: 'text.summarization',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.sentence.similarity');
        },
        value: 'sentence.similarity',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.pretraining');
        },
        value: 'pretraining',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.natural.language.inference');
        },
        value: 'natural.language.inference',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.text.correction');
        },
        value: 'text.correction',
      },
      {
        get label() {
          return i18n.t('home:market.model.capability.embedding');
        },
        value: 'market.model.capability.embedding',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.feature.extraction');
        },
        value: 'feature.extraction',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.sentiment.analysis');
        },
        value: 'sentiment.analysis',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.relation.extraction');
        },
        value: 'relation.extraction',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.zero.shot.classification');
        },
        value: 'zero.shot.classification',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.table.question.answering');
        },
        value: 'table.question.answering',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.question.answering');
        },
        value: 'question.answering',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.part.of.speech.tagging');
        },
        value: 'part.of.speech.tagging',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.entity.classification');
        },
        value: 'entity.classification',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.sequence.tagging');
        },
        value: 'sequence.tagging',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.task.oriented.dialogue');
        },
        value: 'task.oriented.dialogue',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.semantic.relevance');
        },
        value: 'semantic.relevance',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.faq.question.answering');
        },
        value: 'faq.question.answering',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.text.segmentation');
        },
        value: 'text.segmentation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.end.to.end.text.generation');
        },
        value: 'end.to.end.text.generation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.extractive.summarization');
        },
        value: 'extractive.summarization',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.translation.quality.evaluation');
        },
        value: 'translation.quality.evaluation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.general.information.extraction');
        },
        value: 'general.information.extraction',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.chatbot');
        },
        value: 'chatbot',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.twin.general.information.extraction');
        },
        value: 'twin.general.information.extraction',
      },
    ],
  },
  {
    get label() {
      return i18n.t('data-center:ops.option.speech');
    },
    value: 'speech',
    children: [
      {
        get label() {
          return i18n.t('data-center:model.experience.audio.transcription');
        },
        value: 'model.experience.audio.transcription',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.speech.synthesis');
        },
        value: 'speech.synthesis',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.speech.wake.up');
        },
        value: 'speech.wake.up',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.speech.denoising');
        },
        value: 'speech.denoising',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.echo.cancellation');
        },
        value: 'echo.cancellation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.speech.separation');
        },
        value: 'speech.separation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.audio.classification');
        },
        value: 'audio.classification',
      },
      {
        get label() {
          return i18n.t('data-center:model.capability.modality.audioGeneration');
        },
        value: 'model.capability.modality.audioGeneration',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.speaker.verification');
        },
        value: 'speaker.verification',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.speaker.diarization');
        },
        value: 'speaker.diarization',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.punctuation.prediction');
        },
        value: 'punctuation.prediction',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.timestamp.prediction');
        },
        value: 'timestamp.prediction',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.voice.activity.detection');
        },
        value: 'voice.activity.detection',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.perplexity.calculation');
        },
        value: 'perplexity.calculation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.speech.language.recognition');
        },
        value: 'speech.language.recognition',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.audio.quantization.coding');
        },
        value: 'audio.quantization.coding',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.audio.video.speech.recognition');
        },
        value: 'audio.video.speech.recognition',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.emotion.recognition');
        },
        value: 'emotion.recognition',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.inverse.text.normalization');
        },
        value: 'inverse.text.normalization',
      },
    ],
  },
  {
    get label() {
      return i18n.t('data-center:ops.option.computer.vision');
    },
    value: 'computer.vision',
    children: [
      {
        get label() {
          return i18n.t('data-center:ops.option.visual.detection.and.tracking');
        },
        value: 'visual.detection.and.tracking',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.general.object.detection');
            },
            value: 'general.object.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.domain.specific.object.detection');
            },
            value: 'domain.specific.object.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.card.detection.and.rectification');
            },
            value: 'card.detection.and.rectification',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.action.detection');
            },
            value: 'action.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.few.shot.image.object.detection');
            },
            value: 'few.shot.image.object.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.open.vocabulary.object.detection');
            },
            value: 'open.vocabulary.object.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.3d.object.detection');
            },
            value: '3d.object.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.object.detection');
            },
            value: 'video.object.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.single.object.video.tracking');
            },
            value: 'single.object.video.tracking',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.multi.object.video.tracking');
            },
            value: 'multi.object.video.tracking',
          },
        ],
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.optical.character.recognition');
        },
        value: 'optical.character.recognition',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.text.detection');
            },
            value: 'text.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.text.recognition');
            },
            value: 'text.recognition',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.license.plate.detection');
            },
            value: 'license.plate.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.table.structure.recognition');
            },
            value: 'table.structure.recognition',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.borderless.table.structure.recognition');
            },
            value: 'borderless.table.structure.recognition',
          },
        ],
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.face.and.body');
        },
        value: 'face.and.body',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.face.detection');
            },
            value: 'face.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.face.liveness.detection');
            },
            value: 'face.liveness.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.face.recognition');
            },
            value: 'face.recognition',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.face.generation');
            },
            value: 'face.generation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.2d.facial.keypoints');
            },
            value: '2d.facial.keypoints',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.facial.expression.recognition');
            },
            value: 'facial.expression.recognition',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.facial.emotion.recognition');
            },
            value: 'facial.emotion.recognition',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.facial.attribute.recognition');
            },
            value: 'facial.attribute.recognition',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.face.quality.assessment');
            },
            value: 'face.quality.assessment',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.human.detection');
            },
            value: 'human.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.2d.human.keypoints');
            },
            value: '2d.human.keypoints',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.3d.human.keypoints');
            },
            value: '3d.human.keypoints',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.full.body.keypoint.detection');
            },
            value: 'full.body.keypoint.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.head.detection');
            },
            value: 'head.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.hand.detection');
            },
            value: 'hand.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.2d.hand.keypoints');
            },
            value: '2d.hand.keypoints',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.2d.hand.gesture.semantic.recognition');
            },
            value: '2d.hand.gesture.semantic.recognition',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.unified.face.body.and.hand.detection');
            },
            value: 'unified.face.body.and.hand.detection',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.crowd.density.estimation');
            },
            value: 'crowd.density.estimation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.person.re.identification');
            },
            value: 'person.re.identification',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.portrait.beautification');
            },
            value: 'portrait.beautification',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.portrait.enhancement');
            },
            value: 'portrait.enhancement',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.human.reshaping');
            },
            value: 'human.reshaping',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.pedestrian.structured.attribute.recognition');
            },
            value: 'pedestrian.structured.attribute.recognition',
          },
        ],
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.vision.classification');
        },
        value: 'vision.classification',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.general.classification');
            },
            value: 'general.classification',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.animal.recognition');
            },
            value: 'animal.recognition',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.general.object.recognition');
            },
            value: 'general.object.recognition',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.action.recognition');
            },
            value: 'action.recognition',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.short.video.content.recognition');
            },
            value: 'short.video.content.recognition',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.live.video.content.recognition');
            },
            value: 'live.video.content.recognition',
          },
        ],
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.vision.editing');
        },
        value: 'vision.editing',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.image.inpainting');
            },
            value: 'image.inpainting',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.image.colorization');
            },
            value: 'image.colorization',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.sky.replacement');
            },
            value: 'sky.replacement',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.image.example.replacement');
            },
            value: 'image.example.replacement',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.colorization');
            },
            value: 'video.colorization',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.editing');
            },
            value: 'video.editing',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.frame.interpolation');
            },
            value: 'video.frame.interpolation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.stabilization');
            },
            value: 'video.stabilization',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.restoration');
            },
            value: 'video.restoration',
          },
        ],
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.vision.segmentation');
        },
        value: 'vision.segmentation',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.general.matting');
            },
            value: 'general.matting',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.portrait.matting');
            },
            value: 'portrait.matting',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.general.image.segmentation');
            },
            value: 'general.image.segmentation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.text.guided.image.segmentation');
            },
            value: 'text.guided.image.segmentation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.semantic.segmentation');
            },
            value: 'semantic.segmentation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.general.product.segmentation');
            },
            value: 'general.product.segmentation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.image.based.driving.perception');
            },
            value: 'image.based.driving.perception',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.product.saliency.segmentation');
            },
            value: 'product.saliency.segmentation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.portrait.matting');
            },
            value: 'video.portrait.matting',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.scene.segmentation');
            },
            value: 'video.scene.segmentation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.object.segmentation');
            },
            value: 'video.object.segmentation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.panoptic.segmentation');
            },
            value: 'video.panoptic.segmentation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.text.guided.video.object.segmentation');
            },
            value: 'text.guided.video.object.segmentation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.summarization');
            },
            value: 'video.summarization',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.text.guided.video.summarization');
            },
            value: 'text.guided.video.summarization',
          },
        ],
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.vision.generation');
        },
        value: 'vision.generation',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.style.transfer');
            },
            value: 'style.transfer',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.portrait.cartoonization');
            },
            value: 'portrait.cartoonization',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.face.fusion');
            },
            value: 'face.fusion',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.motion.generation');
            },
            value: 'motion.generation',
          },
        ],
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.vision.representation');
        },
        value: 'vision.representation',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.product.image.features');
            },
            value: 'product.image.features',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.representation');
            },
            value: 'video.representation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.multimodal.representation');
            },
            value: 'video.multimodal.representation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.text.cross.modal.retrieval');
            },
            value: 'video.text.cross.modal.retrieval',
          },
        ],
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.vision.evaluation');
        },
        value: 'vision.evaluation',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.image.quality.mos.assessment');
            },
            value: 'image.quality.mos.assessment',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.image.quality.degradation.analysis');
            },
            value: 'image.quality.degradation.analysis',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.anomalous.image.detection');
            },
            value: 'anomalous.image.detection',
          },
        ],
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.low.level.vision');
        },
        value: 'low.level.vision',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.image.super.resolution');
            },
            value: 'image.super.resolution',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.image.color.enhancement');
            },
            value: 'image.color.enhancement',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.image.denoising');
            },
            value: 'image.denoising',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.image.deblurring');
            },
            value: 'image.deblurring',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.image.demoireing');
            },
            value: 'image.demoireing',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.image.debanding');
            },
            value: 'image.debanding',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.image.depth.estimation');
            },
            value: 'image.depth.estimation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.deinterlacing');
            },
            value: 'video.deinterlacing',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.depth.estimation');
            },
            value: 'video.depth.estimation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.video.super.resolution');
            },
            value: 'video.super.resolution',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.optical.flow');
            },
            value: 'optical.flow',
          },
        ],
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.3d.vision');
        },
        value: '3d.vision',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.image.to.3d');
            },
            value: 'image.to.3d',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.face.reconstruction');
            },
            value: 'face.reconstruction',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.image.matching');
            },
            value: 'image.matching',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.virtual.try.on');
            },
            value: 'virtual.try.on',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.panoramic.depth.estimation');
            },
            value: 'panoramic.depth.estimation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.multi.view.depth.estimation');
            },
            value: 'multi.view.depth.estimation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.point.cloud.scene.flow.prediction');
            },
            value: 'point.cloud.scene.flow.prediction',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.indoor.layout.estimation');
            },
            value: 'indoor.layout.estimation',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.nerf.fast.3d.reconstruction.model');
            },
            value: 'nerf.fast.3d.reconstruction.model',
          },
          {
            get label() {
              return i18n.t('data-center:ops.option.human.reconstruction');
            },
            value: 'human.reconstruction',
          },
        ],
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.foundation.model.applications');
        },
        value: 'foundation.model.applications',
        children: [
          {
            get label() {
              return i18n.t('data-center:ops.option.foundation.model.fine.tuning');
            },
            value: 'foundation.model.fine.tuning',
          },
        ],
      },
    ],
  },
  {
    get label() {
      return i18n.t('data-center:ops.option.scientific.computing');
    },
    value: 'scientific.computing',
    children: [
      {
        get label() {
          return i18n.t('data-center:ops.option.protein.structure.generation');
        },
        value: 'protein.structure.generation',
      },
      {
        get label() {
          return i18n.t('data-center:ops.option.protein.function.prediction');
        },
        value: 'protein.function.prediction',
      },
    ],
  },
];
